module.exports = __webpack_public_path__ + "img/pustules.f41e3210.svg";